import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, categories } from '@/mocks/data';

const featuredArticles = articles.filter((a) => a.featured);
const recentArticles = articles.slice(0, 6);
const nonFeaturedCategories = categories.filter((c) => c.slug !== 'all');

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '淫乱小镇',
    url: 'https://hzhgjs.cn',
    description: '原创都市情感故事阅读平台，汇集悬疑剧情、都市情感、人物传奇等精彩短篇故事。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hzhgjs.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '淫乱小镇',
    url: 'https://hzhgjs.cn',
    description: '原创都市情感故事阅读平台',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20small%20town%20at%20dusk%20with%20winding%20cobblestone%20streets%2C%20traditional%20architecture%20with%20warm%20glowing%20lanterns%2C%20misty%20atmosphere%2C%20cinematic%20wide%20shot%2C%20deep%20amber%20and%20teal%20color%20palette%2C%20artistic%20painterly%20style%2C%20moody%20and%20atmospheric&width=1800&height=800&seq=hero-bg-home&orientation=landscape"
              alt="淫乱小镇"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
            <div className="relative z-10 w-full text-center px-4 md:px-6">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide">
                淫乱小镇
              </h1>
              <p className="text-base md:text-xl text-white/80 max-w-2xl mx-auto mb-6 leading-relaxed">
                在每一个看似平静的小镇背后，都藏着无数动人的故事。爱情、背叛、秘密与救赎——在这里，我们讲述那些被时光掩埋的真实人性和情感。
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <Link
                  to="/category/urban-romance"
                  className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  开始阅读
                </Link>
                <Link
                  to="/about"
                  className="px-6 py-2.5 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
                >
                  了解我们
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="max-w-6xl mx-auto px-4 md:px-6 -mt-8 relative z-20" id="story-categories">
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5">
              <CategoryTabs categories={nonFeaturedCategories} activeSlug="" basePath="/category" />
            </div>
          </section>

          {/* Featured Articles */}
          <section className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
                <strong>精选推荐</strong>
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.slice(0, 3).map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          </section>

          {/* Latest Articles */}
          <section className="max-w-6xl mx-auto px-4 md:px-6 pb-10 md:pb-14">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
                <strong>最新故事</strong>
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {recentArticles.map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative w-full py-16 md:py-20 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20soft%20lamp%20light%2C%20open%20book%20on%20wooden%20table%2C%20steaming%20tea%20cup%2C%20window%20showing%20rainy%20evening%2C%20atmospheric%20and%20inviting%2C%20rich%20brown%20and%20gold%20tones&width=1800&height=500&seq=cta-bg-home&orientation=landscape"
              alt="阅读时光"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50"></div>
            <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3">
                每个深夜，都有故事在等你
              </h2>
              <p className="text-white/75 text-sm md:text-base mb-6 leading-relaxed">
                关注我们的微信公众号"淫乱小镇"，每周第一时间获取最新故事推送。不错过每一个精彩的夜晚。
              </p>
              <span className="inline-block px-6 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap">
                关注公众号
              </span>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}